import React from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Swal from 'sweetalert2'
import './AddDrivers.css'
// import "./AddVehicleDrawer.css";
import { useSelector } from 'react-redux';
// import { addVehicle } from "../../redux/AdminReducer";
import { addVehicle } from "../../redux/AdminReducer";
import Offcanvas from "react-bootstrap/Offcanvas";
import Select from 'react-select'

import { useState } from "react";
import { addDriver } from "../../redux/AdminReducer";
import { useDispatch } from "react-redux";
const AddDrivers = () => {

  const dispatch=useDispatch();
  const vehicleData=useSelector((state)=>state?.AdminReducer?.allVehiclesData)
  const driversData = useSelector(
    (state) => state?.AdminReducer?.getAllDriversData
  );
  const options = [
    { value: 'Mercedes E', label: 'Mercedes E' },
    { value: 'Mercedes V', label: 'Mercedes V' },
    { value: 'Mercedes S', label: 'Mercedes S' }
  ]
  const [vehicle,setVehicle]=useState({
        name:"",
        email:"",
        phone:"",
        address:"",
        password:"",
        type:""
     

  });

  const [imageVehicle, setImageVehicle] = useState();
  const handleChange=(e)=>{

    const{name,value}=e.target;

    console.log("e...............",e)

    setVehicle({
      ...vehicle,[name]:value
    })

  }
  const availabilityChange=(e)=>{

    

    console.log("e...............",e)

    setVehicle({
      ...vehicle,availability:!vehicle.availability
    })

  }


  const handleImage=(e)=>{
    const selected1 = e.target.files[0];

    setImageVehicle(selected1);

  }

  console.log("DriverVehicle",vehicle)

  const addBtnClicked=async()=>{

    const data = new FormData();
    data.append("name", vehicle.name);
    data.append("email", vehicle.email);
    data.append("phone", vehicle.phone);
    data.append("address", vehicle.address);
    data.append("type", vehicle.type);
  
   
   const response=await dispatch(addDriver({vehicle,driversData}))

console.log("response",response?.payload?.message)

    
  }

  const handleChangeType=(e)=>{
    console.log("handleChangeTypee",e.value)

    setVehicle({...vehicle,type:e.value})

  }

  return (
    <>
      {[false].map((expand) => (
        <Navbar key={expand} bg="light" expand={expand} className="mb-3">
          <Container fluid>
            {/* <Navbar.Brand href="#">Navbar Offcanvas</Navbar.Brand> */}
            {/* <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} /> */}

            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
              className="btnAddVehicle"
            >
              Add Driver
            </Navbar.Toggle>
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
              className="addVehicleDrawer"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  Add Driver
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="mainAddVehicleDrawerFields">
                
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Name :</div>
                    <input
                      placeholder="Please Enter Name"
                      className="inputFieldAddVeh"
                      name="name"
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                 
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Phone Number :</div>
                    <input
                      placeholder="Please Enter Phone Number"
                      className="inputFieldAddVeh"
                      name="phone"
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Address :</div>
                    <input
                      placeholder="Please Enter Address"
                      className="inputFieldAddVeh"
                      name="address"
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Vehicle Type:</div>
                    <Select options={options} 
                      className="inputFieldAddVeh inputFieldAddVeh1"
                      name="type"
                      onChange={(e)=>handleChangeType(e)}
                    
                    />

                  </div>

                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Email :</div>
                    <input
                      placeholder="Please Enter Company Name"
                      className="inputFieldAddVeh"
                      name="email"
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>

                  <div className="topCatagoryField">
                    <div className="catagoryTxtAddVeh">Password :</div>
                    <input
                      placeholder="Please Enter Password"
                      className="inputFieldAddVeh"
                      name="password"
                      type="password"
                      onChange={(e)=>handleChange(e)}
                    />
                  </div>
               
                  {/* <div className="topCatagoryField topCatagoryFieldCheck">
                    <div className="catagoryTxtAddVeh">Availability :</div>
                    <label class="switch1">
                      <input type="checkbox" 
                      
                      name="availability"
                      onChange={(e)=>availabilityChange(e)}
                      />
                      <span class="slider1 round1"></span>
                    </label>
                  </div> */}
                  <div className="topCatagoryField topCatagoryFieldCheck">
                   
                  <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
           
            >
             <button className="cnclBtn">
                        Cancel
                    </button>
            </Navbar.Toggle>
               
            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-${expand}`}
           
            >
                    
                    <button className="addBtn" onClick={addBtnClicked}>
                        Add
                        </button>
                        </Navbar.Toggle>
                  </div>
                </div>
                
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
};

export default AddDrivers;
